import React from "react";

function ContentSection() {
    return (
        <section className="w-full max-w-2xl mx-auto mt-12 mb-8 px-4 sm:px-6 space-y-10">
            {/* How to Play */}
            <div>
                <h2 className="text-lg font-bold text-white mb-3">
                    How to Play Sports Connections
                </h2>
                <p className="text-slate-300 text-sm leading-relaxed mb-3">
                    Each day, Sports Connections presents you with a fresh 4x4 grid
                    of 16 words drawn from the world of professional sports. Your
                    goal is to sort them into four groups of four, where every word
                    in a group shares a hidden connection. Select four words you
                    believe belong together and hit Submit to check your answer.
                </p>
                <p className="text-slate-300 text-sm leading-relaxed mb-3">
                    You have up to four mistakes before the game ends, so think
                    carefully before guessing. Each correct group is color-coded by
                    difficulty: yellow is the most straightforward, green and blue
                    are trickier, and purple is the hardest. Start with the group
                    you feel most confident about and work your way through.
                </p>
                <p className="text-slate-300 text-sm leading-relaxed">
                    Switch between NFL, NBA, and MLB puzzles using the sport toggle
                    at the top of the page. Every league gets its own daily puzzle,
                    so there are three chances to play each day.
                </p>
            </div>

            {/* Daily Puzzles */}
            <div>
                <h2 className="text-lg font-bold text-white mb-3">
                    Daily Puzzles for Every Sports Fan
                </h2>
                <p className="text-slate-300 text-sm leading-relaxed mb-3">
                    Sports Connections publishes new puzzles daily across all three
                    major leagues. Whether you bleed football, live for basketball,
                    or follow every pitch of the baseball season, there is a puzzle
                    waiting for you.
                </p>
                <ul className="space-y-2 text-slate-300 text-sm">
                    <li>
                        <span className="text-white font-semibold">NFL</span> &mdash; Group
                        players by draft class, match quarterbacks to their divisions,
                        connect teams that share a stadium city, or identify Pro Bowl
                        selections from the same season.
                    </li>
                    <li>
                        <span className="text-white font-semibold">NBA</span> &mdash; Link
                        teammates from championship rosters, sort players by jersey
                        number, group franchises by conference, or find connections
                        between All-Star MVPs.
                    </li>
                    <li>
                        <span className="text-white font-semibold">MLB</span> &mdash; Identify
                        World Series champions by decade, match players to their
                        career milestone stats, sort teams by league, or connect
                        Hall of Famers who played the same position.
                    </li>
                </ul>
            </div>

            {/* Tips & Strategy */}
            <div>
                <h2 className="text-lg font-bold text-white mb-3">
                    Tips & Strategy
                </h2>
                <ul className="space-y-3 text-slate-300 text-sm">
                    <li>
                        <span className="text-white font-semibold">
                            Scan the whole board first.
                        </span>{" "}
                        Before guessing, read all 16 words and look for obvious
                        clusters. You will often spot the easiest group right away.
                    </li>
                    <li>
                        <span className="text-white font-semibold">
                            Start with what you know.
                        </span>{" "}
                        If four words clearly belong together, lock them in early.
                        Removing a solved group shrinks the board and makes the
                        remaining connections easier to see.
                    </li>
                    <li>
                        <span className="text-white font-semibold">
                            Watch for red herrings.
                        </span>{" "}
                        Puzzle creators love overlapping connections. A player name
                        might fit two categories, but only one grouping uses all
                        four slots correctly. If you get a "one away" warning, one
                        of your picks belongs elsewhere.
                    </li>
                    <li>
                        <span className="text-white font-semibold">
                            Think beyond the obvious.
                        </span>{" "}
                        The purple (hardest) group often relies on wordplay, hidden
                        patterns, or less well-known trivia. If the connection is
                        not immediately clear, consider abbreviations, nicknames,
                        or off-field references.
                    </li>
                    <li>
                        <span className="text-white font-semibold">
                            Use the Shuffle button.
                        </span>{" "}
                        Rearranging the grid can break mental ruts and help you spot
                        groupings you missed in the original layout.
                    </li>
                </ul>
            </div>
        </section>
    );
}

export default ContentSection;
